<div
  class="gd-form-datetime-range-v2"
  fxLayout="row">

  <!-- From -->
  <app-form-number-v2
    *ngIf="!fromHidden"
    fxFlex
    [name]="name + '[from]'"
    [(ngModel)]="value.from"
    placeholder="LNG_FORM_RANGE_FIELD_LABEL_FROM"
    autocomplete="off"
    [neverFloatLabel]="neverFloatLabel"
    [disabled]="disabled"
    [required]="required"
    [min]="min"
    [max]="max"
    (ngModelChange)="onChange(value)"
    (blurEvent)="onTouchItem()"></app-form-number-v2>

  <!-- Separator -->
  <div
    *ngIf="!fromHidden && !toHidden"
    fxLayoutAlign="center center"
    class="gd-form-datetime-range-separator-v2">
    —
  </div>

  <!-- To -->
  <app-form-number-v2
    *ngIf="!toHidden"
    fxFlex
    [name]="name + '[to]'"
    [(ngModel)]="value.to"
    placeholder="LNG_FORM_RANGE_FIELD_LABEL_TO"
    autocomplete="off"
    [neverFloatLabel]="neverFloatLabel"
    [disabled]="disabled"
    [required]="required"
    [min]="min"
    [max]="max"
    (ngModelChange)="onChange(value)"
    (blurEvent)="onTouchItem()"></app-form-number-v2>

</div>
